import { Injectable } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class RedirectCleanupService {
  private cleared = false;

  clearOnce() {
    if (!this.cleared) {
      localStorage.removeItem('returnUrl');
      this.cleared = true;
    }
  }
}
